<template>
    <ModalFormCard :action="action" :submittedCallback="submittedCallback" class="modal-default">
        <template #title>Add new payment method</template>

        <template #default="{ saving, errors }">
            <Input
                v-model:value="value.name_on_card"
                :disabled="isSaving(saving)"
                class="w-full"
                groupClass="bg-grey text-15"
                label="Cardholder name"
                name="name_on_card"
                placeholder="Enter cardholder name"
            />

            <Stripe ref="stripe" :disabled="isSaving(saving)" class="mt-4" @complete="stripeCompleted" @error="stripeErrored" />

            <Input
                v-model:value="value.address_line_1"
                :disabled="isSaving(saving)"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Address"
                name="address_line_1"
                placeholder="Address line 1"
            />
            <Input
                v-model:value="value.address_line_2"
                :disabled="isSaving(saving)"
                class="mt-1"
                groupClass="bg-grey text-15"
                name="address_line_2"
                placeholder="Address line 2"
            />
            <Input
                v-model:value="value.town"
                :disabled="isSaving(saving)"
                class="mt-1"
                groupClass="bg-grey text-15"
                name="town"
                placeholder="Town or City"
            />
            <Input
                v-model:value="value.postcode"
                :disabled="isSaving(saving)"
                class="mt-1"
                groupClass="bg-grey text-15"
                name="postcode"
                placeholder="Post code"
            />

            <div class="grid grid-cols-4 pt-6">
                <ButtonSaving :disabled="isSaving(saving)" class="button-black h-12 col-span-2"> Add new card </ButtonSaving>

                <button :disabled="saving" type="button" class="button-purple default" @click="$emit('close')">Cancel</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import PaymentMethod from '~/models/payment-method.js'
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    created() {
        this.setup(PaymentMethod)
    },

    methods: {
        submittedCallback(res) {
            this.saving = true

            this.$refs.stripe.stripeAttemptPayment(res.intent, res.billing_address)
        },

        stripeCompleted() {
            this.$event.$emit('modal-form-completed')
            this.$emit('close')
        },

        stripeErrored() {
            this.saving = false
        },
    },
}
</script>
